<template>
  <div class="Input">
    <span class="label" :style="{ width: labelWidth || '80px' }" v-if="label">{{ label }}</span>
    <div class="input_box">
      <div class="input_boxcross">
        <input
          v-model="col"
          :placeholder="placeholder"
          :type="type"
          v-bind="$attrs"
          :readonly="readonly"
          @input="
            e => {
              onCheck(e);
            }
          "
          :disabled="disabled"
          @blur="blurHandler"
          :maxlength="maxlength"
          ref="Field"
        />

        <van-icon v-show="col.length" @click="clickDelete" class="cross" name="cross" />
      </div>
      <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script>
import Schema from 'async-validator';

export default {
  name: 'Input',
  props: [
    'props',
    'placeholder',
    'reg',
    'maxlength',
    'type',
    'disabled',
    'value',
    'label',
    'labelWidth',
    'border',
    'prop',
    'separate',
    'readonly',
    'toUpperCase',
    'blur',
  ],
  data() {
    return {
      col: '',
      errorMessage: '',
      isDelete: false,
    };
  },
  watch: {
    col: {
      handler(newVal, oldVal) {
        this.$emit('input', newVal);
      },
      immediate: true,
    },
  },
  methods: {
    blurHandler() {
      this.onCheck();
    },
    onCheck(val) {
      return new Promise((resolve) => {
        if (val) {
          this.col = val.target.value;
        }
        const test = 'test';
        if (!this.reg) resolve(true);
        const validator = new Schema({
          [test]: this.reg,
        });
        const value = this.col;
        validator.validate({ [test]: value }, (errors) => {
          if (errors) {
            this.errorMessage = errors[0].message;
            resolve(false);
          } else {
            this.errorMessage = '';
            resolve(true);
          }
        });
      });
    },
    clickDelete() {
      this.col = '';
      this.onCheck();
    },
  },
};
</script>
<style scoped lang="scss">
.Input {
  display: flex;
  background: #fff;
  padding: 12px 16px;
  position: relative;
}
input {
  width: 70%;
  border: 0;
  font-size: 14px;
  padding: 0;
  margin: 0;
}
.label {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1c2438;
  display: flex;
  align-items: center;
}
.error-message {
  position: absolute;
  color: #ee0a24;
  font-size: 12px;
  bottom: 0px;
}
.input_box {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.input_boxcross {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
  input {
    font-size: 16px;
  }
}
.input_boxcross > input:disabled {
  color: #495060;
  -webkit-text-fill-color: #495060;
  -webkit-opacity: 1;
  opacity: 1;
}
.input_boxcross {
  input::-webkit-input-placeholder {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #bcc2cc;
    line-height: 24px;
    font-weight: 400;
  }

  input::-moz-input-placeholder {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #bcc2cc;
    line-height: 24px;
    font-weight: 400;
  }

  input::-ms-input-placeholder {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #bcc2cc;
    line-height: 24px;
    font-weight: 400;
  }
}

.cross {
  color: #9e9fa0;
}
input:disabled {
  background-color: #fff !important;
}
</style>
